import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableHead,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import { ProjectsData, TasksData } from '../SettingsData';
import SettingsTableCells from '../SettingsTableCells/SettingsTableCells';

// Original class: settingsTableWrap
const StyledSettingsTableWrap = styled(Grid)(({ theme }) => ({
  width: '100%',
  background: '#FFFFFF',
  borderRadius: theme.spacing(2),
  boxShadow: '0px 5px 10px -8px #212346',
}));
// Original class: boxWrap
const StyledBoxWrap = styled(Box)(theme => ({
  width: '100%',
}));
// Original class: spentTimeTableRoot
const StyledSpentTimeTableRoot = styled(Table)(theme => ({
  backgroundColor: '#ffffff',

  '& .MuiTableCell-root': {
    border: '1px solid #e4e4ef',
    borderBottom: 0,
    borderTop: 0,
  },

  '& .MuiTableBody-root': {
    borderBottom: '1px solid #e4e4ef',
  },

  '& .MuiTableCell-head': {
    borderTop: '1px solid #e4e4ef',
    borderBottom: '1px solid #e4e4ef',
  },
}));

const SettingsProjectTasks = ({ intl }) => {
  const taskName = intl.formatMessage({ id: 'settings_task_name' });
  const taskOpened = intl.formatMessage({ id: 'settings_task_opened' });
  const taskClosed = intl.formatMessage({ id: 'settings_task_closed' });
  const projectName = intl.formatMessage({ id: 'settings_project_name' });
  const projectRole = intl.formatMessage({ id: 'settings_project_role' });
  const projectRegdate = intl.formatMessage({
    id: 'settings_project_reg_date',
  });

  return (
    <>
      <StyledSettingsTableWrap
        item
        container
        xs={6}
        sx={{
          marginTop: 5,
          gap: 7,
          position: 'relative',
          justifyContent: 'space-between',
          padding: 5,
        }}
      >
        <StyledBoxWrap
          sx={{
            position: 'relative',
          }}
        >
          <Typography
            variant='h3'
            sx={{
              marginBottom: 5,
              fontWeight: 600,
            }}
          >
            <FormattedMessage
              id='settings_task_header'
              defaultMessage='Tasks'
            />
          </Typography>
          <StyledSpentTimeTableRoot>
            <TableHead>
              <TableRow>
                <SettingsTableCells
                  content={taskName}
                  weight='700'
                  style={{ width: '70%' }}
                />
                <SettingsTableCells
                  content={taskOpened}
                  weight='700'
                  style={{ width: '15%' }}
                />
                <SettingsTableCells
                  content={taskClosed}
                  weight='700'
                  style={{ width: '15%' }}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {TasksData.map(task => (
                <TableRow key={task.id}>
                  <SettingsTableCells content={task.name} />
                  <SettingsTableCells content={task.open} />
                  <SettingsTableCells content={task.close} />
                </TableRow>
              ))}
            </TableBody>
          </StyledSpentTimeTableRoot>
        </StyledBoxWrap>
      </StyledSettingsTableWrap>
      <StyledSettingsTableWrap
        item
        container
        xs={6}
        sx={{
          marginTop: 5,
          gap: 7,
          position: 'relative',
          padding: 5,
        }}
      >
        <StyledBoxWrap
          sx={{
            position: 'relative',
          }}
        >
          <Typography
            variant='h3'
            sx={{
              marginBottom: 5,
              fontWeight: 600,
            }}
          >
            <FormattedMessage
              id='settings_project_header'
              defaultMessage='Projects'
            />
          </Typography>
          <StyledSpentTimeTableRoot>
            <TableHead>
              <TableRow>
                <SettingsTableCells
                  content={projectName}
                  weight='700'
                  style={{ width: '30%' }}
                />
                <SettingsTableCells
                  content={projectRole}
                  weight='700'
                  style={{ width: '60%' }}
                />
                <SettingsTableCells
                  content={projectRegdate}
                  weight='700'
                  style={{ width: '30%' }}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {ProjectsData.map(project => (
                <TableRow key={project.id}>
                  <SettingsTableCells content={project.name} />
                  <SettingsTableCells content={project.role} />
                  <SettingsTableCells content={project.reg} />
                </TableRow>
              ))}
            </TableBody>
          </StyledSpentTimeTableRoot>
        </StyledBoxWrap>
      </StyledSettingsTableWrap>
    </>
  );
};

export default injectIntl(SettingsProjectTasks);
